import { render, staticRenderFns } from "./collectInformation.vue?vue&type=template&id=f29672b4&scoped=true&"
import script from "./collectInformation.vue?vue&type=script&lang=js&"
export * from "./collectInformation.vue?vue&type=script&lang=js&"
import style0 from "./collectInformation.vue?vue&type=style&index=0&id=f29672b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29672b4",
  null
  
)

export default component.exports